module.exports = __webpack_public_path__ + "img/spinner.e9a5c1b0.svg";